<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="close()">&#xe03e;</button>
    <h2>{{ 'Admin.SideMenu.AddNewChangeSet' | translate }}</h2>
  </div>
  <form #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="cald_content">
            <cpq-input-error [label]="{key:'xsltName'}" #name="ngModel" [control]='name' [name]="'name'"
              [(ngModel)]="model.name" (keydown.enter)="save()"  maxlength="100" [cpqRequired]='true'>
            </cpq-input-error>

            <cpq-textarea [label]="{key: 'xsltDescription'}" #description="ngModel" [name]="'description'"
              [control]="description" [(ngModel)]='model.description' maxlength="250" (keydown.enter)="save()">
            </cpq-textarea>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" (click)="save()" [disabled]="form.invalid">{{'Admin.Msg.Save' | translate}}</button>
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" (click)="close()">{{'Msg.Cancel' | translate}}</button>
  </div>
</div>